import { Component, Inject, OnInit, Input } from '@angular/core';
import { Logo_Path } from '@webdpt/framework';
import { ActivatedRoute, Router,RouterModule, Routes } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @Input() modalScope: any;  // 登陆开窗
  public isPassword = false;
  constructor(private router: Router,
    private route: ActivatedRoute,
    @Inject(Logo_Path) public dwLogoPath: string,
  ) { }

  ngOnInit(): void { }

  receiveDataFromChild(data: boolean) {
    this.isPassword = data;
  }

}

